// Cache storage
export const saveInfo = async (data) => {
  if (data) {
    const json = JSON.stringify(data);
    localStorage.setItem('user_info', json);
  }
  return await data;
};

export const getInfo = () => {
  const json = localStorage.getItem('user_info');
  if (json) {
    return JSON.parse(json);
  }
  return json;
};

export const saveRoles = (roleArr) => {
  let json = [];
  if (roleArr) {
    json = JSON.stringify(fnMapRoles(roleArr));
  }
  localStorage.setItem('user_roles', json);
};

export const getRoles = () => {
  const json = localStorage.getItem('user_roles');
  if (json) {
    return JSON.parse(json);
  }
  return [];
};

export const savePermissions = (data) => {
  let json = {};
  if (data) {
    json = JSON.stringify(data);
    localStorage.setItem('user_permissions', json);
  }
};

export const getPermissions = () => {
  const json = localStorage.getItem('user_permissions');
  try {
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export const saveAccessLevel = (data) => {
  let json = {};
  if (data) {
    json = JSON.stringify(data);
    localStorage.setItem('user_access_level', json);
  }
};

export const getAccessLevel = () => {
  const json = localStorage.getItem('user_access_level');
  try {
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export const cleanCache = () => {
  localStorage.removeItem('user_roles');
  localStorage.removeItem('user_info');
  localStorage.removeItem('current_user_role');
  localStorage.removeItem('user_permissions');
  localStorage.removeItem('user_access_level');
};

const fnMapRoles = (roleArr) => {
  const listItems = [];
  roleArr.forEach((item, index) => {
    if (2 === item) {
      listItems.push({ id: item, name: 'r-teacher' });
    } else if (4 === item) {
      listItems.push({ id: item, name: 'r-officer' });
    } else if (8 === item) {
      listItems.push({ id: item, name: 'r-leader' });
    } else if (16 === item) {
      listItems.push({ id: item, name: 'r-accountant' });
    } else if (32 === item) {
      listItems.push({ id: item, name: 'r-admin' });
    } else if (64 === item) {
      listItems.push({ id: item, name: 'r-seller' });
    } else if (128 === item) {
      listItems.push({ id: item, name: 'r-censor' });
    } else if (256 === item) {
      listItems.push({ id: item, name: 'r-highest' });
    }
  });
  fnCurrentRole(listItems);
  return listItems;
};

const fnCurrentRole = (arrays) => {
  if (arrays && arrays.length > 0) {
    const firstItem = arrays[0];
    localStorage.setItem('current_user_role', firstItem.name);
  }
};

export const refreshCurrentRole = (newRole) => {
  if (newRole) {
    localStorage.setItem('current_user_role', newRole);
  } else {
    newRole = localStorage.getItem('current_user_role');
    if (!newRole) {
      newRole = 'Guest';
    }
  }
  return newRole;
};

export const getRoleCode = () => {
  return localStorage.getItem('current_user_role');
};
